import EduAppApiPublic from "@/EduAppApiPublic";

export default {
  getAuswahlwerte: async (langId: string) => {
    try {
      const response = await EduAppApiPublic.get(
        `auswahlwerte/agriviva/?langId=${langId}`
      );
      return response.data as Record<string, any>;
    } catch (error) {
      console.error("Error fetching auswahlwerte:", error); // Handle error appropriately
      return {};
    }
  },
};
